

/*
 * Search JS
 */

/* global $biro_body */
var $biro_search_form;
var $biro_search_toggle;
var biro_search_form_open;


// On page load
jQuery( function( $ ) {

	// Init
	$biro_search_form     = $( '.search-form-wrap-desktop' );
	$biro_search_toggle   = $( '.menu-search-toggle' );
	biro_search_form_open = false;

	// Desktop search toggle
	$biro_search_toggle.on( 'click', function() {

		if ( $biro_search_toggle.attr( 'aria-expanded' ) === 'false' ) {

			// Close any nav menus
			biro_menu_close_all();

			// Open overlay
			biro_overlay_open();

			// Open search
			$biro_search_toggle.parents( 'li' ).css( 'z-index', 99999 ).addClass( 'is-open' );
			$biro_search_toggle.attr( 'aria-expanded', 'true' );
			$biro_search_form.fadeIn(
				200,
				function() {
					$biro_search_form.find( '.search-text' ).focus();
					biro_search_form_open = true;
				}
			);

		} else {

			// Close
			biro_search_form_close();

		}

	});

	// Overlay close
	$biro_body.on( 'biro:overlay:close', function() {
		biro_search_form_close();
	});

	// Search input typing
	$biro_body.on( 'keyup', 'input[type="search"]', function() {

		// Init
		var $el  = $( this );
		var $sfs = $el.parents( '.search-form-search' );

		// Flag whether there's text, for 'clear' button
		if ( $el.val() === '' ) {
			$sfs.removeClass( 'has-text' );
		} else {
			$sfs.addClass( 'has-text' );
		}

	});

	// Search input clear
	$biro_body.on( 'click', '.search-clear', function() {

		// Init
		var $el  = $( this );
		var $sfs = $el.parents( '.search-form-search' );
		var $st  = $el.siblings( '.search-text' );

		$st.val( '' ).focus();
		$sfs.removeClass( 'has-text' );

	});

	// Focus form on results if nothing entered
	if ( $biro_body.hasClass( 'search' ) ) {

		// Init
		$str = $( '#search-text-results' );

		if ( ! $str.val() ) {
			$str.focus();
		}

	}

});


/**
 * Close search form if open
 *
 * @return {void}
 */
function biro_search_form_close( close_overlay ) {

	if ( biro_search_form_open ) {

		// Init
		close_overlay = ( typeof close_overlay === 'undefined' ) ? true : close_overlay;

		// Close overlay?
		if ( close_overlay ) {
			biro_overlay_close();
		}

		// Close search form
		$biro_search_form.fadeOut(
			200,
			function() {
				$biro_search_toggle.parents( 'li' ).css( 'z-index', 'initial' ).removeClass( 'is-open' );
				$biro_search_toggle.attr( 'aria-expanded', 'false' ).blur();
				biro_search_form_open = false;
			}
		);

	}

}
